import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import { resetUpdateLabReportMessage } from "../../../../store/slices/labReportSlice";
import {
  getAllRadiologyReport,
  updateRadiologyReport,
  resetUpdateRadiologyReportMessage,
} from "../../../../store/slices/radiologyReport";
import { useDispatch, useSelector } from "react-redux";
import ReportDetails from "./editRadiologyReport/reportDetails";
import CollectionReceived from "./editRadiologyReport/collectionReceived";
import LabOutsource from "./editRadiologyReport/labOutsource";
import ServiceDetails from "./editRadiologyReport/serviceDetails";
import AssignedAndRemark from "./editRadiologyReport/assignedAndRemark";
import ReportStatus from "./editRadiologyReport/reportStatus";
import ShowTostifyMessageAndReset from "../../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../../common/tostify/Toastifyresponse";

const EditRadiologyReport = ({ activeTab }) => {
  const dispatch = useDispatch();
  const showMessageAndReset = ShowTostifyMessageAndReset();
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { token } = useSelector((state) => state.auth);
  const { labReportUpdateSuccessMessage, labReportUpdateErrorMessage } =
    useSelector((state) => state.labReport);
  const {
    radiologyReports,
    updateRadiologyReportSuccessMessage,
    updateRadiologyReportErrorMessage,
  } = useSelector((state) => state.radiologyReport);
  const { userInfo } = useSelector((state) => state.auth);
  const radiologyReportId = sessionStorage.getItem("radiologyReportId");
  const newRadiologyReports = radiologyReports[0];
  const [radiologyReportFormData, setRadiologyReportFormData] = useState({
    collectionDate: "",
    collectionTime: "",
    receivedDate: "",
    receivedTime: "",
    assignedPhysician: "",
    assignedPhysicianName: "",
    remark: "",
    labReportStatus: "",
    labForOutsource: "",
    labForOutsourceName: "",
    id: newRadiologyReports?._id,
  });
  const [selectAllOutsource, setSelectAllOutsource] = useState(false);
  const [globalOutsourceLab, setGlobalOutsourceLab] = useState(null);
  const clinicId = clinicInfo?.[0]?.clinicId || null;
  const clinicObjId = clinicInfo?.[0]?._id;
  useEffect(() => {
    dispatch(
      getAllRadiologyReport({
        clinicId,
        reportId: radiologyReportId,
        token,
      }),
    );
  }, [dispatch, clinicId, radiologyReportId, token]);

  useEffect(() => {
    setRadiologyReportFormData((prevState) => ({
      ...prevState,
      collectionDate: newRadiologyReports?.collectionDate
        ? new Date(newRadiologyReports.collectionDate)
            .toISOString()
            .split("T")[0]
        : "",
      collectionTime: newRadiologyReports?.collectionTime || "",
      receivedDate: newRadiologyReports?.receivedDate
        ? new Date(newRadiologyReports.receivedDate).toISOString().split("T")[0]
        : "",
      receivedTime: newRadiologyReports?.receivedTime || "",
      assignedPhysician: newRadiologyReports?.assignedPhysician?._id || "",
      assignedPhysicianName:
        newRadiologyReports?.assignedPhysician?.userId?.name || "",
      remark: newRadiologyReports?.remark || "",
      labReportStatus: newRadiologyReports?.labReportStatus || "",
      labForOutsource: newRadiologyReports?.labForOutsource?._id || "",
      labForOutsourceName:
        newRadiologyReports?.labForOutsource?.clinicName || "",
      outsourceBy: clinicObjId,
      clinicId,
      serviceName: newRadiologyReports?.radiologyServiceInfo?.serviceName,
      serviceDetails:
        newRadiologyReports?.radiologyServiceInfo?.serviceDetails?.map(
          (test) => ({
            id: test._id,
            serviceDetailsName: test.serviceDetailsName,
            weight: test.weight,
            pt_price: test.pt_price,
            client_Price: test.client_Price,
            tax: test.tax,
            description: test?.description,
            sourceType: test.sourceType || "",
            labForOutsource: test?.labForOutsource?._id || "",
            labForOutsourceName: test?.labForOutsource?.clinicName || "",
            outsourceBy: clinicObjId,
          }),
        ) || [],
    }));
    setGlobalOutsourceLab({
      value: newRadiologyReports?.labForOutsource?._id || "",
      label: newRadiologyReports?.labForOutsource?.clinicName || "",
    });
    if (newRadiologyReports?.labForOutsource?._id) {
      setSelectAllOutsource(true);
    }
  }, [dispatch, newRadiologyReports, clinicInfo]);

  useEffect(() => {
    showMessageAndReset(
      labReportUpdateSuccessMessage,
      showToastifySuccess,
      resetUpdateLabReportMessage,
    );
    showMessageAndReset(
      labReportUpdateErrorMessage,
      showToastifyError,
      resetUpdateLabReportMessage,
    );
    showMessageAndReset(
      updateRadiologyReportSuccessMessage,
      showToastifySuccess,
      resetUpdateRadiologyReportMessage,
    );
    showMessageAndReset(
      updateRadiologyReportErrorMessage,
      showToastifyError,
      resetUpdateRadiologyReportMessage,
    );
  }, [
    labReportUpdateSuccessMessage,
    labReportUpdateErrorMessage,
    dispatch,
    showMessageAndReset,
    updateRadiologyReportSuccessMessage,
    updateRadiologyReportErrorMessage,
  ]);

  const handleChange = (e, name) => {
    if (name === "outsourceLab") {
      setRadiologyReportFormData({
        ...radiologyReportFormData,
        labForOutsource: e.value,
        labForOutsourceName: e.label,
      });
    } else if (name === "assignedPhysician") {
      setRadiologyReportFormData({
        ...radiologyReportFormData,
        assignedPhysician: e.value,
        assignedPhysicianName: e.label,
      });
    } else {
      setRadiologyReportFormData({
        ...radiologyReportFormData,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleTestProfileChange = (e, name, index, testIds) => {
    const newValue = e.target ? e.target.value : e.value;
    setRadiologyReportFormData((prevState) => {
      const updatedTests = prevState.serviceDetails.map((test) =>
        test.id === index
          ? {
              ...test,
              [name]: newValue,
              ...(name === "labForOutsource" && {
                labForOutsource: e.value,
                labForOutsourceName: e.label,
                outsourceBy: clinicObjId,
              }),
            }
          : test,
      );
      return {
        ...prevState,
        serviceDetails: updatedTests,
      };
    });
    if (name === "labForOutsource") {
      setRadiologyReportFormData((prevState) => ({
        ...prevState,
        labForOutsource: "",
        labForOutsourceName: "",
      }));
      setGlobalOutsourceLab({
        value: "",
        label: "",
      });
      setSelectAllOutsource(false);
    }
  };

  const handleAddDescription = (e, editor, serviceId) => {
    const updatedDescription = editor.getData();
    setRadiologyReportFormData((prevState) => {
      const updatedServiceDetails = prevState.serviceDetails.map((service) =>
        service.id === serviceId
          ? { ...service, description: updatedDescription }
          : service,
      );
      return {
        ...prevState,
        serviceDetails: updatedServiceDetails,
      };
    });
  };

  const handleUpdateRadiologyReport = (e) => {
    e.preventDefault();
    dispatch(
      updateRadiologyReport({
        radiologyDetails: {
          ...radiologyReportFormData,
          id: newRadiologyReports?._id,
          updatedBy: userInfo?._id,
        },
        token,
      }),
    );
  };

  const handleSelectAllOutsourceToggle = () => {
    setSelectAllOutsource((prevSelectAllOutsource) => {
      const newSelectAllOutsource = !prevSelectAllOutsource;
      setRadiologyReportFormData((prevState) => ({
        ...prevState,
        serviceDetails: prevState.serviceDetails.map((test) => ({
          ...test,
          sourceType: newSelectAllOutsource ? "outSource" : "inHouse",
        })),
      }));
      return newSelectAllOutsource;
    });
  };

  useEffect(() => {
    if (selectAllOutsource && globalOutsourceLab) {
      setRadiologyReportFormData((prevState) => ({
        ...prevState,
        serviceDetails: prevState.serviceDetails.map((test) => ({
          ...test,
          sourceType: "outSource",
          labForOutsource: globalOutsourceLab.value,
        })),
      }));
    }
  }, [selectAllOutsource, globalOutsourceLab, setRadiologyReportFormData]);

  const handleGlobalRadiologyServiceChange = (selectedOption) => {
    setGlobalOutsourceLab(selectedOption);
    if (selectAllOutsource) {
      setRadiologyReportFormData((prevState) => ({
        ...prevState,
        labForOutsource: selectedOption.value || "",
        labForOutsourceName: selectedOption.label || "",
        outsourceBy: clinicObjId,
        serviceDetails: prevState.serviceDetails.map((test) => ({
          ...test,
          labForOutsource: selectedOption.value,
          labForOutsourceName: selectedOption.label,
        })),
      }));
    }
  };

  const handleIndividualLabChange = (selectedOption, id, type) => {
    setRadiologyReportFormData((prevState) => ({
      ...prevState,
      [type]: prevState[type].map((item) =>
        item.id === id
          ? { ...item, labForOutsource: selectedOption.value }
          : item,
      ),
    }));
  };

  return (
    <>
      <form onSubmit={handleUpdateRadiologyReport}>
        <ReportDetails />
        <CollectionReceived
          radiologyReportFormData={radiologyReportFormData}
          handleChange={handleChange}
        />
        <LabOutsource
          radiologyReportFormData={radiologyReportFormData}
          handleChange={handleChange}
          handleSelectAllOutsourceToggle={handleSelectAllOutsourceToggle}
          selectAllOutsource={selectAllOutsource}
          handleGlobalRadiologyServiceChange={
            handleGlobalRadiologyServiceChange
          }
          globalOutsourceLab={globalOutsourceLab}
        />
        <ServiceDetails
          radiologyReportFormData={radiologyReportFormData}
          handleChange={handleChange}
          newRadiologyReports={newRadiologyReports}
          handleTestProfileChange={handleTestProfileChange}
          selectAllOutsource={selectAllOutsource}
          setSelectAllOutsource={setSelectAllOutsource}
          setRadiologyReportFormData={setRadiologyReportFormData}
          handleIndividualLabChange={handleIndividualLabChange}
          handleAddDescription={handleAddDescription}
        />
        <AssignedAndRemark
          radiologyReportFormData={radiologyReportFormData}
          handleChange={handleChange}
        />
        <ReportStatus
          radiologyReportFormData={radiologyReportFormData}
          handleChange={handleChange}
        />
        <br />
        <div className="text-end">
          <Button variant="primary" type="submit" className="p-2">
            Submit
          </Button>
        </div>
      </form>
    </>
  );
};

export default EditRadiologyReport;
